/** Les mots de la boutique de gestes : la page et son squelette posent les mêmes intitulés. */
export const SHOP_TEXTS = {
    title: "Boutique de gestes",
    balance: "Tes crédits",
    empty: "Aucun geste pour le moment",
}
